import { render, staticRenderFns } from "./DMPSplit.vue?vue&type=template&id=7b7902b0&scoped=true"
import script from "./DMPSplit.vue?vue&type=script&lang=js"
export * from "./DMPSplit.vue?vue&type=script&lang=js"
import style0 from "./DMPSplit.vue?vue&type=style&index=0&id=7b7902b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7902b0",
  null
  
)

export default component.exports